import { render, staticRenderFns } from "./BenefitsLadingPage.vue?vue&type=template&id=7fd85fa4&scoped=true&lang=html"
import script from "./BenefitsLadingPage.vue?vue&type=script&lang=js"
export * from "./BenefitsLadingPage.vue?vue&type=script&lang=js"
import style0 from "./BenefitsLadingPage.vue?vue&type=style&index=0&id=7fd85fa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd85fa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd85fa4')) {
      api.createRecord('7fd85fa4', component.options)
    } else {
      api.reload('7fd85fa4', component.options)
    }
    module.hot.accept("./BenefitsLadingPage.vue?vue&type=template&id=7fd85fa4&scoped=true&lang=html", function () {
      api.rerender('7fd85fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BenefitsLadingPage.vue"
export default component.exports